export const emailPattern = /^[\w-.]+@([\w-]+\.)+[\w-]{2,4}$/;
export const phonePattern = /^\+\d{6,}$/;
export const phonePatternLT = /^\+370[6-9]\d{7}$/;
export const phonePatternLTWithZero = /^0[6-9]\d{7}$/;
